var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_makeshop_integration.html';
var html = "<span translate=sites.campaigns.edit.instruction.makeshopIntegration translate-value-service={{$ctrl.ZcsOemService.getName()}}></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/instruction_makeshop_integration.html
// module id = 1394
// module chunks = 0